// utils/productCache.js

import { API_URL } from "../config/api";

let cache = null;
let loadingPromise = null;

// 🔥 obtener productos (1 sola llamada global)
export const getProducts = async () => {
  try {
    // ✅ si ya hay cache → devolverla
    if (cache) {
      return cache;
    }

    // ✅ si ya hay request en curso → reutilizarla
    if (loadingPromise) {
      return loadingPromise;
    }

    // 🚀 hacer fetch solo una vez
    loadingPromise = fetch(`${API_URL}/products`)
      .then((res) => {
        if (!res.ok) throw new Error("Error al obtener productos");
        return res.json();
      })
      .then((data) => {
        cache = data;
        loadingPromise = null;

        return cache;
      })
      .catch((err) => {
        loadingPromise = null;
        throw err;
      });

    return loadingPromise;

  } catch (err) {
    console.error("❌ productCache error:", err);
    throw err;
  }
};

// 🔥 resetear cache (lo llamas en Home)
export const resetCache = () => {
  cache = null;
  loadingPromise = null;
};

// 🔥 obtener categorías (sin repetir lógica)
export const getCategories = async () => {
  const products = await getProducts();

  const normalize = (text) =>
    text
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const seen = new Set();
  const categories = [];

  products.forEach((p) => {
    const norm = normalize(p.category);

    if (!seen.has(norm)) {
      seen.add(norm);
      categories.push(p.category);
    }
  });

  return categories;
};

// 🔥 obtener producto por ID (SIN llamar API)
export const getProductById = async (id) => {
  const products = await getProducts();

  return products.find(
    (p) => String(p.product_id) === String(id)
  );
};

/* =====================================================
   💳 INTEGRACIÓN MERCADO PAGO
===================================================== */

// Crear preferencia de Mercado Pago
export const createPreference = async (cartItems) => {
  try {
    const response = await fetch(`${API_URL}/create-preference`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: cartItems }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ Backend error:", data);
      throw new Error(
        data?.details || data?.error || "Error al crear preferencia"
      );
    }

    return data;

  } catch (error) {
    console.error("❌ createPreference:", error);
    throw error;
  }
};

export const goToCheckout = async (cartItems) => {
  try {
    const data = await createPreference(cartItems);

    if (data && data.init_point) {
      // 🔥 CAMBIO CLAVE: .assign es más "limpio" para el navegador 
      // y ayuda a evitar bloqueos de scripts CSP en redirecciones
      window.location.assign(data.init_point);
    } else {
      throw new Error("No se recibió init_point");
    }

  } catch (error) {
    console.error("❌ Error al iniciar pago:", error);
    alert(`No se pudo iniciar el pago: ${error.message}`);
  }
};